import { render } from "./MarketplaceJobs.vue?vue&type=template&id=c015ac3e&scoped=true"
import script from "./MarketplaceJobs.vue?vue&type=script&lang=js"
export * from "./MarketplaceJobs.vue?vue&type=script&lang=js"

import "./MarketplaceJobs.vue?vue&type=style&index=0&id=c015ac3e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c015ac3e"]])

export default __exports__